export default "__VITE_ASSET__BMNFaKi9__"